module.exports = __webpack_public_path__ + "static/media/jeel-series.01c4f0d7.png";